/* eslint-disable no-plusplus */
import React, { Component } from "react";
import { Tree, Spin, Input, Tooltip } from "antd";
import { connect } from "dva";
import styles from "./index.less";

const { TreeNode, DirectoryTree } = Tree;
const { Search } = Input;

const getItemList = (tree, arr = []) => {
  if (tree && tree.length) {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      const { id, name, number, code } = node;
      arr.push({ id, name: `${number}${name}`, code });
      if (node.child) {
        getItemList(node.child, arr);
      }
    }
    return arr;
  }
  return arr;
};

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.child) {
      if (node.child.some(item => item.id === key)) {
        parentKey = node.id;
      } else if (getParentKey(key, node.child)) {
        parentKey = getParentKey(key, node.child);
      }
    }
  }
  return parentKey || key;
};

const getNowNodeKey = tree => {
  let nowNodeKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.child) {
      nowNodeKey = getNowNodeKey(node.child);
    } else {
      nowNodeKey = node.id;
    }
  }
  return nowNodeKey || [];
};

@connect(({ tree }) => ({
  ...tree
}))
class TreeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
      autoExpandParent: true,
      norememberNode: []
    };
  }

  componentDidMount() {
    const { dispatch, currentselectTreeNode, clearRememberIndex } = this.props;
    const indexId = currentselectTreeNode.code;
    if (clearRememberIndex) {
      dispatch({
        type: "tree/save",
        payload: {
          currentselectTreeNodeIndexId: ""
        }
      });
    } else if (indexId) {
      dispatch({
        type: "tree/save",
        payload: {
          currentselectTreeNodeIndexId: indexId
        }
      });
      this.setState({
        norememberNode: [`${currentselectTreeNode.id}`]
      });
    }
  }

  handleSearch = value => {
    if (value) {
      const { normTreeList } = this.props;
      const groupList = getItemList([normTreeList]);
      // 搜索逻辑
      const expandedKeys = groupList
        .map(item => {
          if (item.name.indexOf(value) > -1) {
            const res = getParentKey(item.id, [normTreeList]);
            return res.toString();
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      this.setState({
        searchValue: value,
        autoExpandParent: true
      });
      this.onExpand(expandedKeys);
    } else {
      this.setState({
        searchValue: ""
      });
    }
  };

  // handleExpandAllTree = () => {
  //   const { normTreeList } = this.props;
  //   const expandedKeys = getNowNodeKey([normTreeList]);
  //   console.log(expandedKeys);
  //   this.onExpand(expandedKeys);
  // };

  handleChange = e => {
    this.setState({
      searchValue: e.target.value
    });
  };

  onSelect = (selectedKeys, info) => {
    const { dispatch, onSelect, needRememberNowNode } = this.props;
    const { treeNodeData } = info.node.props;
    const { type, id, code } = treeNodeData;
    if (onSelect) {
      onSelect({ type, id, code });
    }
    if (needRememberNowNode === 0) {
      this.setState({
        norememberNode: selectedKeys
      });
    } else {
      dispatch({
        type: "tree/save",
        payload: {
          currentselectTreeNode: treeNodeData,
          selectTreeNodeKey: selectedKeys,
          currentselectTreeNodeIndexId: code
        }
      });
    }
  };

  onExpand = expandedKeys => {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/save",
      payload: {
        expandedKeys
      }
    });
  };

  renderTreeList = () => {
    const { autoExpandParent, norememberNode } = this.state;
    const {
      normTreeList,
      selectTreeNodeKey,
      expandedKeys,
      needRememberNowNode,
      expandAllTree
    } = this.props;

    const treeProps = {
      onExpand: this.onExpand,
      expandedKeys,
      autoExpandParent,
      onSelect: this.onSelect,
      selectedKeys:
        needRememberNowNode === 0 ? norememberNode : selectTreeNodeKey
    };

    const expandAllTreeProps = {
      onExpand: this.onExpand,
      defaultExpandAll: true,
      autoExpandParent,
      onSelect: this.onSelect,
      selectedKeys:
        needRememberNowNode === 0 ? norememberNode : selectTreeNodeKey
    };
    return expandAllTree ? (
      <Tree {...expandAllTreeProps}>{this.renderTreeNode(normTreeList)}</Tree>
    ) : (
      <Tree {...treeProps}>{this.renderTreeNode(normTreeList)}</Tree>
    );
  };

  renderTreeNode = data => {
    const { searchValue } = this.state;
    const { number, name, id, numberName } = data;
    const newName = `${number}${name}`;
    const index = newName.indexOf(searchValue);
    const beforeStr = newName.substr(0, index);
    const afterStr = newName.substr(index + searchValue.length);
    const title =
      // eslint-disable-next-line
      index > -1 ? (
        newName?.length > 12 ? (
          <Tooltip className="treeNodeName" title={newName} placement="topLeft">
            {beforeStr}
            <span style={{ color: "#1785EC" }}>{searchValue}</span>
            {afterStr}
          </Tooltip>
        ) : (
          <span className="treeNodeName" placement="topLeft">
            {beforeStr}
            <span style={{ color: "#1785EC" }}>{searchValue}</span>
            {afterStr}
          </span>
        )
      ) : newName?.length > 12 ? (
        <Tooltip className="treeNodeName" title={newName} placement="topLeft">
          {`${newName?.substring(0, 12)}...`}
        </Tooltip>
      ) : (
        <span className="treeNodeName" placement="topLeft">
          {numberName || `${number}${name}`}
        </span>
      );

    return (
      <TreeNode title={title} key={id} treeNodeData={data}>
        {(data.child || []).map(items => {
          return this.renderTreeNode(items);
        })}
      </TreeNode>
    );
  };

  render() {
    const { normTreeList, spinProps } = this.props;
    return (
      <Spin {...spinProps}>
        <div className={styles.treeList}>
          <div className="search-wrap">
            <Search
              placeholder="请输入指标编号或名称"
              onChange={this.handleChange}
              onSearch={this.handleSearch}
            />
          </div>
          {normTreeList ? this.renderTreeList() : <Spin tip="数据加载中..." />}
        </div>
      </Spin>
    );
  }
}

export default TreeList;
